import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {CardState, listExpand, rotateArrow} from "../../../animations";

@Component({
  selector: 'as-filter-item',
  templateUrl: './filter-item.component.html',
  styleUrls: ['./filter-item.component.scss'],
  animations: [listExpand, rotateArrow]
})
export class FilterItemComponent implements OnInit {
  @Output() onChange = new EventEmitter();

  @Input() header: string;
  @Input() items = [];
  @Input() type: string;
  @Input() index;
  @Input() resetItems;

  state = [];
  selectedValue = 0;

  constructor() {
  }

  ngOnInit() {

    this.resetItems.subscribe((e) => {
      if (e == "reset-filter-data") {
        this.uncheckItems();
      }
    })

    if (this.index == 0) {
      this.state[this.index] = CardState.Open;
    } else {
      this.state[this.index] = CardState.Closed;
    }

    this.uncheckItems();
  }

  handleChange(index) {
    this.items[index].checked = !this.items[index].checked;
    this.items[index]["key"] = this.header;

    this.onChange.emit(this.items)
  }

  handleSelectChange(event) {

    let index = 0;
    this.items.forEach((e, inx) => {
      e.checked = false;
      if (e.value == event.target.value) {
        index = inx;
      }
    })
    this.handleChange(index);
  }

  expandSubList(index) {
    this.state[index] = (this.state[index] == CardState.Open) ? CardState.Closed : CardState.Open;
  }

  uncheckItems() {
    this.items.map((curr) => {
      curr["checked"] = false;
    })
  }
}

